import { Box, SxProps, useTheme } from '@mui/material'
import React from 'react'

interface Props {
  sx?: SxProps
}

/**
 * Component to indicate new content
 */
const NewDot: React.FC<Props> = ({ sx }) => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        height: 8,
        width: 8,
        borderRadius: '100%',
        backgroundColor: theme.palette.primary.main,
        ...sx,
      }}
    />
  )
}

export default NewDot
